import { useState, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ChevronLeft, Phone, MapPin, Clock, Camera, Pen, Check, X, RotateCcw, Loader2, CalendarDays } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { API, compressImage } from "./utils";
import { FullScreenCapture } from "./FullScreenCapture";
import { PhotoGrid } from "./PhotoGrid";

export const TechLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { Input } = require("../ui/input");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/tech/auth/login`, { username, password });
      localStorage.setItem("tech_token", res.data.token);
      localStorage.setItem("tech_username", res.data.username);
      onLogin(res.data.token);
    } catch (err) {
      setError(err.response?.data?.detail || "Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center p-4" data-testid="tech-login">
      <Card className="w-full max-w-sm">
        <CardContent className="pt-6 space-y-4">
          <div className="text-center space-y-1">
            <div className="w-14 h-14 rounded-full bg-blue-500/20 flex items-center justify-center mx-auto mb-3">
              <MapPin size={28} className="text-blue-500" />
            </div>
            <h1 className="text-xl font-bold text-slate-800">Acceso Técnico</h1>
            <p className="text-sm text-slate-500">Introduce tus credenciales</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-3">
            <Input placeholder="Usuario" value={username} onChange={e => setUsername(e.target.value)} autoComplete="username" data-testid="tech-login-username" />
            <Input type="password" placeholder="Contraseña" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" data-testid="tech-login-password" />
            {error && <p className="text-sm text-red-500 text-center" data-testid="tech-login-error">{error}</p>}
            <Button type="submit" className="w-full h-12 text-base font-semibold bg-blue-600 hover:bg-blue-700" disabled={loading} data-testid="tech-login-submit">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Entrar"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
